import React from "react";

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;600&family=Inter:wght@300;400&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .maintenance-root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f9f6f1;
    font-family: 'Inter', sans-serif;
    padding: 40px 24px;
    text-align: center;
  }

  .maintenance-eyebrow {
    font-family: 'Inter', sans-serif;
    font-size: 11px;
    font-weight: 400;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #a89070;
    margin-bottom: 32px;
  }

  .maintenance-divider {
    width: 40px;
    height: 1px;
    background: #c8b49a;
    margin: 0 auto 32px;
  }

  .maintenance-heading {
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: clamp(42px, 8vw, 80px);
    font-weight: 300;
    line-height: 1.1;
    color: #1a1611;
    letter-spacing: -0.01em;
    margin-bottom: 12px;
  }

  .maintenance-heading em {
    font-style: italic;
    font-weight: 300;
    color: #5a4a3a;
  }

  .maintenance-sub {
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: clamp(18px, 3vw, 26px);
    font-weight: 400;
    color: #7a6a58;
    margin-bottom: 48px;
    font-style: italic;
  }

  .maintenance-body {
    font-size: 14px;
    font-weight: 300;
    color: #7a6a58;
    letter-spacing: 0.04em;
    line-height: 1.8;
    max-width: 360px;
    margin: 0 auto;
  }

  .maintenance-footer {
    position: fixed;
    bottom: 28px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 11px;
    font-weight: 400;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #c8b49a;
  }
`;

export default function Maintenance() {
  return (
    <>
      <style>{style}</style>
      <div className="maintenance-root">
        <p className="maintenance-eyebrow">Pansion Franka</p>
        <div className="maintenance-divider" />
        <h1 className="maintenance-heading">
          Currently under
          <br />
          <em>maintenance</em>
        </h1>
        <p className="maintenance-sub">We will be back soon.</p>
        <p className="maintenance-footer">pansionfranka.com</p>
      </div>
    </>
  );
}
